import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const DeleteCommentFromCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCommentFromCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idAction"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCardComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idAction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idAction"}}},{"kind":"Argument","name":{"kind":"Name","value":"traceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"DeleteCommentFromCard","document":DeleteCommentFromCardDocument}} as const;
export type DeleteCommentFromCardMutationVariables = Types.Exact<{
  idAction: Types.Scalars['ID']['input'];
  traceId: Types.Scalars['String']['input'];
}>;


export type DeleteCommentFromCardMutation = (
  { __typename: 'Mutation' }
  & { deleteCardComment?: Types.Maybe<(
    { __typename: 'CardComment_DeleteResponse' }
    & Pick<Types.CardComment_DeleteResponse, 'success'>
  )> }
);

export type DeleteCommentFromCardMutationFn = Apollo.MutationFunction<
  DeleteCommentFromCardMutation,
  DeleteCommentFromCardMutationVariables
>;

/**
 * __useDeleteCommentFromCardMutation__
 *
 * To run a mutation, you first call `useDeleteCommentFromCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentFromCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentFromCardMutation, { data, loading, error }] = useDeleteCommentFromCardMutation({
 *   variables: {
 *      idAction: // value for 'idAction'
 *      traceId: // value for 'traceId'
 *   },
 * });
 */
export function useDeleteCommentFromCardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCommentFromCardMutation,
    DeleteCommentFromCardMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCommentFromCardMutation,
    DeleteCommentFromCardMutationVariables
  >(DeleteCommentFromCardDocument, options);
}
export type DeleteCommentFromCardMutationHookResult = ReturnType<
  typeof useDeleteCommentFromCardMutation
>;
export type DeleteCommentFromCardMutationResult =
  Apollo.MutationResult<DeleteCommentFromCardMutation>;
export type DeleteCommentFromCardMutationOptions = Apollo.BaseMutationOptions<
  DeleteCommentFromCardMutation,
  DeleteCommentFromCardMutationVariables
>;
